import { useRefs, usePerm, useBoundingClientRect, useRefRect } from './hooks'
import { rgbToHex, hexToRgb, generateColors } from './color'
import { debounce, raf, ric, extractValue } from './helpers'
import {
  HAS_DEBUG_FLAG,
  HAS_WINDOW,
  IS_BROWSER,
  IS_PROD,
} from './developmentConstants'

export { HAS_DEBUG_FLAG, HAS_WINDOW, IS_BROWSER, IS_PROD }

export const helpers = {
  debounce,
  raf,
  ric,
  extractValue,
}

export const color = {
  hexToRgb,
  rgbToHex,
  generateColors,
}

export const hooks = {
  useRefs,
  usePerm,
  useBoundingClientRect,
  useRefRect,
}
